<div class="alert-container" [ngClass]="{ warning: type === 'warning', notice: type === 'notice' }">
  <mat-icon class="icon">
    {{ type === 'warning' ? 'warning' : 'error_outline' }}
  </mat-icon>

  <div class="notes">
    <h3>{{ header }}</h3>
    <p #textRef [class.expanded]="expanded">{{ description }}</p>

    <div class="show-more-container" *ngIf="showMore">
      <button class="show-more" (click)="toggleExpanded()">
        {{ expanded ? 'Show less' : 'Show more' }}
      </button>
    </div>
  </div>
</div>